<template>
  <div class="payment-options-wrapper" ref="paymentOptionsWrapper">
    <!-- PAC View (Fintoc) -->
    <template v-if="(havePac && checkFintoc) || (showFintoc && checkFintoc)">
      <div class="back-nav" v-if="!havePac">
        <button class="back-btn" @click="showFintoc = false">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="m15 18-6-6 6-6" />
          </svg>
          Volver a opciones
        </button>
      </div>
      <pacFintoc
        :asset_id="asset_id"
        :project_id="project_id"
        :key="'fin' + asset_id"
        :response_pac="responsePac"
      />
    </template>

    <!-- PAT View (OneClick) -->
    <template
      v-else-if="
        (haveCards && checkOneClick) || (showOneClick && checkOneClick)
      "
    >
      <div class="back-nav" v-if="!haveCards">
        <button class="back-btn" @click="showOneClick = false">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="m15 18-6-6 6-6" />
          </svg>
          Volver a opciones
        </button>
      </div>
      <oneclick
        v-if="checkOneClick"
        :asset_id="asset_id"
        :project_id="project_id"
        :key="'one' + asset_id"
      />
    </template>

    <!-- Options Selection View -->
    <template v-else>
      <!-- Header -->
      <div class="options-header">
        <div class="contract-info">
          <div class="contract-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
              />
            </svg>
          </div>
          <div class="contract-details">
            <span class="contract-label">Automatiza tus pagos</span>
            <span class="contract-number">Pagos Automáticos</span>
          </div>
        </div>
        <div class="options-count">
          <span class="count-badge">
            {{ availableOptionsCount }}
            {{
              availableOptionsCount === 1
                ? "opción disponible"
                : "opciones disponibles"
            }}
          </span>
        </div>
      </div>

      <!-- Main Content -->
      <div class="options-content">
        <!-- Hero Section -->
        <div class="hero-section">
          <div class="hero-illustration">
            <div class="floating-icons">
              <div class="icon-float calendar">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
                  <line x1="16" x2="16" y1="2" y2="6" />
                  <line x1="8" x2="8" y1="2" y2="6" />
                  <line x1="3" x2="21" y1="10" y2="10" />
                  <path d="m9 16 2 2 4-4" />
                </svg>
              </div>
              <div class="icon-float check">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
              <div class="icon-float bell">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
                  <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
                </svg>
              </div>
              <div class="icon-float money">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
                  />
                </svg>
              </div>
            </div>
            <img
              :src="require('@/assets/images/working.png')"
              alt="Pagos Automáticos"
              class="hero-image"
            />
          </div>
          <div class="hero-content">
            <h2 class="hero-title">
              ¡Olvídate de pagar tus cuotas manualmente!
            </h2>
            <p class="hero-description">
              Configura el pago automático y nosotros nos encargamos del resto.
              Tus pagos se realizarán puntualmente sin que tengas que
              preocuparte.
            </p>
            <ul class="hero-benefits">
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                Pagos puntuales sin retrasos
              </li>
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                100% seguro y confiable
              </li>
              <li>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                Puedes cancelarlo cuando quieras
              </li>
            </ul>
          </div>
        </div>

        <!-- Options Cards -->
        <div class="options-grid">
          <!-- PAC Option -->
          <div class="option-card" v-if="checkFintoc" @click="selectPac()">
            <div
              class="option-badge recommended"
              v-if="checkFintoc && checkOneClick"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polygon
                  points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
                />
              </svg>
              Recomendado
            </div>
            <div class="option-icon pac">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect width="20" height="14" x="2" y="5" rx="2" />
                <line x1="2" x2="22" y1="10" y2="10" />
              </svg>
            </div>
            <div class="option-content">
              <h3 class="option-title">Cuenta Corriente</h3>
              <p class="option-subtitle">PAC - Pago Automático</p>
              <p class="option-description">
                Conecta tu cuenta corriente bancaria y automatiza todos tus
                pagos directamente desde tu banco.
              </p>
            </div>
            <div class="option-footer">
              <button class="option-btn" @click.stop="selectPac()">
                <span>Configurar PAC</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M5 12h14" />
                  <path d="m12 5 7 7-7 7" />
                </svg>
              </button>
            </div>
          </div>

          <!-- PAT Option -->
          <div class="option-card" v-if="checkOneClick" @click="selectPat()">
            <div class="option-icon pat">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect width="20" height="14" x="2" y="5" rx="2" />
                <line x1="2" x2="22" y1="10" y2="10" />
                <path d="M6 14h.01" />
                <path d="M10 14h4" />
              </svg>
            </div>
            <div class="option-content">
              <h3 class="option-title">Tarjeta de Crédito</h3>
              <p class="option-subtitle">PAT - Pago Automático con Tarjeta</p>
              <p class="option-description">
                Registra tu tarjeta de crédito y nosotros realizaremos los
                cargos automáticamente cada mes.
              </p>
            </div>
            <div class="option-footer">
              <button class="option-btn secondary" @click.stop="selectPat()">
                <span>Configurar PAT</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M5 12h14" />
                  <path d="m12 5 7 7-7 7" />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- Security Note -->
        <div class="security-note">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
            <path d="m9 12 2 2 4-4" />
          </svg>
          <p>
            Tus datos están protegidos con encriptación de nivel bancario. No
            almacenamos información sensible de tus cuentas.
          </p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import oneclick from "../oneclick/Oneclick";
import pacFintoc from "./pacs/PacFintoc";

export default {
  name: "paymentOptions",
  components: {
    oneclick,
    pacFintoc,
  },
  props: {
    asset_id: null,
    project_id: { default: null },
  },
  data() {
    return {
      havePac: null,
      showFintoc: false,
      showOneClick: false,
      responsePac: null,
    };
  },
  mounted() {
    this.checkPac();
  },
  computed: {
    contract_id() {
      return this.$store.getters.getContractId == undefined
        ? null
        : this.$store.getters.getContractId;
    },
    haveCards() {
      if (this.$store.getters.getCards) {
        return this.$store.getters.getCards.length > 0 ? true : false;
      } else {
        return false;
      }
    },
    checkFintoc() {
      if (this.$store.getters.getCustomerData) {
        return this.$store.getters.getCustomerData.products.find(
          (product) => product.name == "Fintoc"
        )
          ? true
          : false;
      } else {
        return false;
      }
    },
    checkOneClick() {
      if (this.$store.getters.getCustomerData) {
        return this.$store.getters.getCustomerData.products.find(
          (product) => product.name == "Pago One Click"
        )
          ? true
          : false;
      } else {
        return false;
      }
    },
    availableOptionsCount() {
      let count = 0;
      if (this.checkFintoc) count++;
      if (this.checkOneClick) count++;
      return count;
    },
  },
  methods: {
    selectPac() {
      this.showFintoc = true;
      this.scrollToTop();
    },
    selectPat() {
      this.showOneClick = true;
      this.scrollToTop();
    },
    scrollToTop() {
      this.$nextTick(() => {
        const element = this.$refs.paymentOptionsWrapper;
        if (element) {
          const navbarHeight = 70;
          const extraOffset = 100;
          const elementPosition =
            element.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - navbarHeight - extraOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }
      });
    },
    checkPac() {
      let self = this;
      this.axios
        .get(`payments/get_fintoc_pacs?contract_id=${this.contract_id}`)
        .then((result) => {
          self.havePac = result.data ? true : false;
          self.responsePac = result.data;
          if (result.data) this.$store.commit("setAutomatedPayments", true);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    parseDate(date) {
      return this.$moment(date).format("DD-MM-YYYY");
    },
  },
  watch: {
    contract_id: function (new_val) {
      if (new_val) this.checkPac();
    },
  },
};
</script>

<style scoped>
/* ===== Wrapper ===== */
.payment-options-wrapper {
  padding: 0;
}

/* ===== Back Navigation ===== */
.back-nav {
  margin-bottom: 16px;
}

.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s ease;
}

.back-btn:hover {
  background: #f9fafb;
  border-color: #d1d5db;
}

/* ===== Header ===== */
.options-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 20px;
  padding: 20px 24px;
  margin-bottom: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
}

.contract-info {
  display: flex;
  align-items: center;
  gap: 16px;
}

.contract-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
  border-radius: 12px;
  color: #059669;
}

.contract-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.contract-label {
  font-size: 0.8125rem;
  color: #6b7280;
  font-weight: 500;
}

.contract-number {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1f2937;
}

.count-badge {
  display: inline-flex;
  padding: 8px 16px;
  background: #f0f9ff;
  color: #0369a1;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 500;
}

/* ===== Options Content ===== */
.options-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* ===== Hero Section ===== */
.hero-section {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 40px;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 50%, #f0fdf4 100%);
  border-radius: 24px;
  padding: 40px;
  align-items: center;
}

.hero-illustration {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.floating-icons {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.icon-float {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.icon-float.calendar {
  top: 5%;
  right: 5%;
  background: white;
  color: var(--color-btn, #3b82f6);
  animation: float 3s ease-in-out infinite;
}

.icon-float.check {
  bottom: 10%;
  left: 0%;
  background: #10b981;
  color: white;
  animation: float 3s ease-in-out infinite 0.5s;
}

.icon-float.bell {
  top: 0%;
  left: 10%;
  background: #f59e0b;
  color: white;
  animation: float 3s ease-in-out infinite 1s;
}

.icon-float.money {
  bottom: 15%;
  right: 0%;
  background: linear-gradient(135deg, #059669 0%, #10b981 100%);
  color: white;
  animation: float 3s ease-in-out infinite 1.5s;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
}

.hero-image {
  max-width: 280px;
  width: 100%;
  height: auto;
  filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.1));
}

.hero-content {
  padding: 16px 0;
}

.hero-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 16px;
  line-height: 1.3;
}

.hero-description {
  font-size: 1rem;
  color: #4b5563;
  line-height: 1.6;
  margin-bottom: 24px;
}

.hero-benefits {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.hero-benefits li {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.9375rem;
  color: #374151;
  font-weight: 500;
}

.hero-benefits li svg {
  color: #10b981;
  flex-shrink: 0;
}

/* ===== Options Grid ===== */
.options-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
}

.option-card {
  position: relative;
  background: white;
  border-radius: 20px;
  padding: 28px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 2px solid #e5e7eb;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.option-card:hover {
  border-color: var(--color-btn, #3b82f6);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transform: translateY(-4px);
}

.option-badge {
  position: absolute;
  top: 16px;
  right: 16px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
}

.option-badge.recommended {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  color: #92400e;
}

.option-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 20px;
}

.option-icon.pac {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  color: #2563eb;
}

.option-icon.pat {
  background: linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%);
  color: #db2777;
}

.option-content {
  flex: 1;
}

.option-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 4px;
}

.option-subtitle {
  font-size: 0.8125rem;
  color: var(--color-btn, #3b82f6);
  font-weight: 600;
  margin-bottom: 12px;
}

.option-description {
  font-size: 0.9375rem;
  color: #6b7280;
  line-height: 1.5;
  margin: 0;
}

.option-footer {
  padding-top: 4px;
}

.option-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 14px 24px;
  background: var(--color-btn, #3b82f6);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 0.9375rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.option-btn:hover {
  opacity: 0.9;
}

.option-btn.secondary {
  background: #f3f4f6;
  color: #374151;
}

.option-btn.secondary:hover {
  background: #e5e7eb;
}

/* ===== Security Note ===== */
.security-note {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px 20px;
}

.security-note svg {
  color: #10b981;
  flex-shrink: 0;
  margin-top: 2px;
}

.security-note p {
  font-size: 0.875rem;
  color: #64748b;
  line-height: 1.5;
  margin: 0;
}

/* ===== Responsive ===== */
@media (max-width: 1024px) {
  .hero-section {
    grid-template-columns: 1fr;
    padding: 32px;
    text-align: center;
  }

  .hero-illustration {
    order: -1;
  }

  .hero-image {
    max-width: 220px;
  }

  .hero-benefits {
    align-items: center;
  }
}

@media (max-width: 768px) {
  .options-header {
    flex-direction: column;
    align-items: stretch;
    padding: 16px;
    gap: 16px;
  }

  .contract-info {
    justify-content: center;
  }

  .options-count {
    text-align: center;
  }

  .hero-section {
    padding: 24px;
    gap: 24px;
  }

  .hero-title {
    font-size: 1.5rem;
  }

  .hero-image {
    max-width: 180px;
  }

  .floating-icons {
    display: none;
  }

  .options-grid {
    grid-template-columns: 1fr;
  }

  .option-card {
    padding: 24px;
  }
}

@media (max-width: 576px) {
  .options-header {
    padding: 12px;
    border-radius: 12px;
  }

  .contract-icon {
    width: 40px;
    height: 40px;
  }

  .contract-icon svg {
    width: 20px;
    height: 20px;
  }

  .contract-number {
    font-size: 1rem;
  }

  .hero-section {
    padding: 20px;
    border-radius: 16px;
  }

  .hero-title {
    font-size: 1.25rem;
  }

  .hero-description {
    font-size: 0.9375rem;
  }

  .hero-image {
    max-width: 150px;
  }

  .option-card {
    padding: 20px;
    border-radius: 16px;
  }

  .option-icon {
    width: 56px;
    height: 56px;
  }

  .option-icon svg {
    width: 24px;
    height: 24px;
  }

  .option-title {
    font-size: 1.125rem;
  }
}
</style>
